<template>
  <div class="panel">
    <div class="menu-title">Menu</div>
    <router-link to="/home">Home</router-link>
    <router-link to="/bookings">My Bookings</router-link>
    <router-link to="/profile">My Profile</router-link>
    <router-link to="/nominees">My Nominees</router-link>
  </div>
</template>
<script>
export default {
  name: "SideBar"
};
</script>

<style scoped lang="scss">
.panel {
  display: none;
  @media (min-width: 992px) {
    display: block;
    overflow: hidden;
    font-size: 1.125rem;
    background-color: #fff;
    border-radius: $border-radius;
    .menu-title {
      color: #fff;
      background-color: $light-black;
    }
    > * {
      display: block;
      text-decoration: none;
      padding: 0.75rem 1.25rem;
      border-bottom: solid 1px $light-gray;
    }
    a {
      color: $light-black;
      &:hover,
      &.router-link-active {
        color: #fff;
        background-color: $orange;
      }
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
